export default "__VITE_ASSET__BNPxGnng__"